import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import ColorList from "./core/ColorList";
import MainNavigation from "./core/Navigation/MainNavigation";

const Routes = () => {
  return (
    <Router>
      <MainNavigation />
      <main>
        <Switch>
          <Route path="/" exact component={ColorList} />
        </Switch>
      </main>
    </Router>
  );
};

export default Routes;
